import React, { useState } from 'react';
import Product from '../Product';
import {ProductGroup, NeuroMessage, ProductPagePropTypes, usePages, contact} from '@ignitesales/neuro-application/src/neuro-guide';
import ContactFormModal from '../modals/ContactFormModal';
import { AnswersList } from '@ignitesales/neuro-application/src/neuro-guide/guide-framework';
import ShareViaEmailModal from '../modals/ShareViaEmailModal';
import ShareViaEmailComplete from '../modals/ShareViaEmailComplete';
import ShareViaSmsModal from '@ignitesales/neuro-application/src/neuro-guide/components/ShareViaSmsModal';
import SuccessFormModal from '../modals/SuccessFormModal';
import PrintButton from             '@ignitesales/neuro-application/src/neuro-guide/components/PrintButton';
import { useUser, useAnswers } from '@ignitesales/neuro-application/src/neuro-guide/hooks';

const TemplateDetailsPage = ({ componentClass, productGroups, answers }) => {
  const { uuid } = useUser();
  const { goToPreviousPage } = usePages();
  const [ showContactFormModal, setShowContactFormModal ] = useState(false);
  const [ showShareViaSmsModal, setShowShareViaSmsModal ] = useState(false);
  const [ showShareViaEmailModal, setShowShareViaEmailModal ] = useState(false);
  const [ showShareViaEmailComplete, setShowShareViaEmailComplete ] = useState(false);
  const [ showSuccessFormModal, setShowSuccessFormModal ] = useState(false);
  const [ selectedProduct, setSelectedProduct ] = useState({});
  const [ leadTransmitted, setLeadTransmitted ] = useState(false);
  const [ onEmailSubmission, setOnEmailSubmission ] = useState(false);
  const [ showAnswers, setShowAnswers ] = useState(false);
  const cssBEM = 'details';

  const renderProductGroup = (productGroup, subGroups, products) => {
    const cssBEM = 'product-group';
    return products.length ?
      <div className={cssBEM} key={ productGroup.name }>
        <div className={ `${ cssBEM }__container` } key={ productGroup.name }>
          { products || null }
        </div>
      </div> : null;
  };

  const openProductUrl = () => window.open( selectedProduct.productUrl,  "_blank" );

  const onProductClick = (params) => {
    setSelectedProduct(params);
    if(leadTransmitted) {
      setShowSuccessFormModal(true);
    } else {
      setShowContactFormModal(true);
    }
  };

  const onContactSuccess = (lead) => {
    setShowContactFormModal(false);
    setShowSuccessFormModal(true);
    setLeadTransmitted(true);

    const sendEmailParams = {
      email: lead.email,
      fromEmail: null,
      copyMe: false,
    };

    if( !onEmailSubmission ) {
      dispatch(sendResultsViaEmail(sendEmailParams));
    }
  };

  const onSuccessAction = (e) => {
    e.preventDefault();
    openProductUrl();
    setShowSuccessFormModal(false);
  };

  const renderProduct = (product) => {
    return <Product 
      key={ product.id }
      product={ product } 
      onClick={ onProductClick }
    />;
  };

  const onEmailComplete = () => {
    setOnEmailSubmission(true);
  };
  // add prop with selectedProduct
  const contactFormModal = (
    <ContactFormModal
      className={`${componentClass}__contactModal contactForm`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showContactFormModal}
      onClose={() => setShowContactFormModal(false)}
      onComplete={ onContactSuccess }
      selectedProduct= { selectedProduct }
    />
  );

  // add onClick to swap the product CTA text to 'selected'
  const successFormModal = (
    <SuccessFormModal
      className={ `${componentClass}__successFormModal` }
      closeBtn={ <i className={'fa fa-times'} /> }
      isOpen={ showSuccessFormModal }
      onClose={ () => setShowSuccessFormModal(false) }
      onSuccessModalClose={ onSuccessAction }
      selectedProduct= { selectedProduct }
    />
  );

  const shareViaSmsModal = (
    <ShareViaSmsModal
      className={`${componentClass}__smsModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaSmsModal}
      onClose={() => setShowShareViaSmsModal(false)}
    />
  );

  const shareViaEmailModal = (
    <ShareViaEmailModal
      className={`${componentClass}__emailModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaEmailModal}
      onClose={() => setShowShareViaEmailModal(false)}
      onEmailComplete={onEmailComplete}
    />
  );

  const shareViaEmailComplete = (
    <ShareViaEmailComplete
      className={`${componentClass}__emailModal emailComplete`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaEmailComplete}
      onClose={() => setShowShareViaEmailComplete(false)}
    />
  );

  const answersToggleButton = () => {
    const iconClass = showAnswers ?  "fa fa-minus-circle" : "fa fa-plus-circle";
    const textAction = showAnswers ?  "Hide My Answers" : "See My Answers";
    return (
    <div className="action--answersList" role="button" onClick={() => { setShowAnswers(!showAnswers)}}>
      {textAction}
      <i className={iconClass} aria-hidden="true"></i>
    </div>
    )
  };

  return (
  <>
    {/* ------------- header ----------------*/}
    <div className={ `${ componentClass }__header` }>
      <div className={ `${ componentClass }__header-text` }>
        <NeuroMessage id="summary.header" tagName='h1' />
        <button class="btn btn-secondary">Schedule An Appointment</button>
      </div>
    </div>
    {/* ------------- products ----------------*/}
    <div className={componentClass}>
      <div className={ `${ componentClass }__products` }>{ productGroups.map(g =>
        <ProductGroup group={ g } renderGroupFn={ renderProductGroup } renderProductFn={ renderProduct } key={ g.name } />
      )}
      </div>
      {/* ------------- header ----------------*/}
      <div className={ `${ componentClass }__footer` }>
        <div className={ `${ componentClass }__footer-left` }>
          {answersToggleButton()}
        </div>
        <div className={ `${ componentClass }__footer-right` }>
          <div className={`${cssBEM}__user`}>
            {uuid && (
            <span>Your recommendation reference #{uuid}</span>
            )}
          </div>
        <div>
          {/* ------------- action-bar ----------------*/}
          <div className={ `${ componentClass }__actionBar` }>
            <div className="actions">
              <div className="sms action" role="button" onClick={() => { setShowShareViaSmsModal(true); }}>
                <span className="fa fa-mobile"/>
                <NeuroMessage id="summary.actions.mobile" tagName='span' />
              </div>
              <div className="email action" role="button" onClick={ onEmailSubmission || leadTransmitted ? () => { setShowShareViaEmailComplete(true); } : () => { setShowShareViaEmailModal(true); } } >
                  <span className="fa fa-envelope"/>
                  <NeuroMessage id="summary.actions.email" tagName='span' />
              </div>
              <PrintButton className="print action" tagName="span">
                <span className="fa fa-print"/>
                <NeuroMessage id="summary.actions.print" tagName='span' />
              </PrintButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* ------------- answers-list ----------------*/}
    { showAnswers &&
        <div className={ `${ componentClass }__answers` } id="answersSection">
        <NeuroMessage id="summary.answers" tagName='h2' />
        <AnswersList />
      </div>
    }

    <div className={ `${ componentClass }__navigation` }>
      <button onClick={goToPreviousPage} className="btn btn-secondary"><NeuroMessage id="nav.prev"/></button>
    </div>

    { contactFormModal }
    { shareViaSmsModal }
    { shareViaEmailModal }
    { shareViaEmailComplete }
    { successFormModal }
  </div>
</>
  );
};
TemplateDetailsPage.propTypes = ProductPagePropTypes;
export default TemplateDetailsPage;